export default __webpack_public_path__ + "static/media/personal.0e48bf11.png";